export default paolaLocationModal => {

    let $modal = $('.compareModal');

    if ($modal.length < 1) {
        return false;
    }

    $('#modal_grayout, .close').on('click', function () {
        $('#modal_grayout, .modal').hide();
    });
};
